export const formatUkNumber = (value) => {
    if (value === undefined || value === null) return '';
    // Accept number or string (trim whitespace)
    const s = String(value).trim();
    if (s === '' || s.toLowerCase() === 'nan') return '';
    // handle sign
    const sign = s[0] === '-' ? '-' : '';
    const unsigned = s.replace(/^-/, '');
    // split integer and decimal parts (keeps everything after first dot as decimal)
    const [intPart, ...decParts] = unsigned.split('.');
    const decPart = decParts.length ? decParts.join('.') : undefined;
    // insert commas into integer part (works for arbitrarily long ints)
    const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decPart !== undefined ? `${sign}${intFormatted}.${decPart}` : `${sign}${intFormatted}`;
}



export const downloadExcelFromHTML = (htmlTable,file_name="file",ext="xls") => {
    const blob = new Blob([htmlTable], {
        type: 'application/vnd.ms-excel',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${file_name}.${ext}`; // file name
    a.click();
    URL.revokeObjectURL(url);
}
